import { REGEX_PATTERNS } from '../../regex';

const CAMEL_TO_KEBAB = REGEX_PATTERNS.caseConversion.CAMEL_TO_KEBAB.regex;
const SPACES_UNDERSCORES_TO_HYPHEN = REGEX_PATTERNS.caseConversion.SPACES_UNDERSCORES_TO_HYPHEN.regex;

/**
 * @group Functions
 * @summary <blockquote>Converts a string to kebab-case.</blockquote>
 *
 * Handles camelCase and PascalCase by inserting hyphens at word boundaries,
 * and replaces spaces/underscores with hyphens, then lowercases.
 *
 * @param str - Input string (e.g. "userName", "UserService", "user name")
 * @returns kebab-case string (e.g. "user-name", "user-service")
 * @example
 * ```typescript
 * toKebabCase('userName');    // 'user-name'
 * toKebabCase('UserService'); // 'user-service'
 * ```
 */
export function toKebabCase(str: string): string {
  return str
    .replace(CAMEL_TO_KEBAB, '$1-$2')
    .replace(SPACES_UNDERSCORES_TO_HYPHEN, '-')
    .toLowerCase();
}
